import { Grid } from "@mui/material";
import { YourCryptoPanel as StyledBorderContainer } from "src/components/portfolio/styles/portifolio.styles";
import { StyledTableDataLabel } from "../staking/staking-styled-components";

export const HistoryMobileCard = ({ coin }: { coin: string }) => {
  return (
    <StyledBorderContainer style={{ marginBottom: "14px" }}>
      <Grid container>
        <Grid item xs={6}>
          <StyledTableDataLabel style={{ color: "#002035" }}>{coin}</StyledTableDataLabel>
        </Grid>
        <Grid item xs={6} textAlign={"right"}>
          <StyledTableDataLabel style={{ color: "#002035" }}>{coin}</StyledTableDataLabel>
        </Grid>

        {/* APY Row */}
        <Grid item xs={6}>
          <StyledTableDataLabel>Date</StyledTableDataLabel>
        </Grid>
        <Grid item xs={6} textAlign={"right"}>
          <StyledTableDataLabel>10 July 2025</StyledTableDataLabel>
        </Grid>
        {/* Available Balance Row */}
        <Grid item xs={6}>
          <StyledTableDataLabel>Coin</StyledTableDataLabel>
        </Grid>
        <Grid item xs={6} textAlign={"right"}>
          <StyledTableDataLabel>Solana</StyledTableDataLabel>
        </Grid>
        {/* Min to Stake Row */}
        <Grid item xs={6}>
          <StyledTableDataLabel>Status</StyledTableDataLabel>
        </Grid>
        <Grid item xs={6} textAlign={"right"}>
          <StyledTableDataLabel>Completed</StyledTableDataLabel>
        </Grid>
      </Grid>
    </StyledBorderContainer>
  );
};
